import RestService from './RestService'

export default class NotificationsService extends RestService {
    constructor() {
        super('notifications')
    }

    list() {
        let url = this.baseUrl + '/api/v1/' + this.modelPath + '.json?t=' + Date.now() + '&app_id=' + webase.model.app.id
        return this.executeGet(url)
    }

}